<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">{{'negotiate_contract.sub_title' | translate}}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <!-- Filter -->
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'enterprise_contract.ttl_search' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form #myForm="ngForm" (ngSubmit)="onFilterData(0, paginate.pageSize)" class="pb-3">
          <div class="row">
            <!-- Tên/số tài liệu -->
            <div class="col-lg-4 col-md-6">
              <mat-form-field class="w-100">
                <input type="text"
                       (focusout)="documents.nameOrCode = documents.nameOrCode == undefined ? '' : (documents.nameOrCode + '').trim()"
                       #focusInput matInput [placeholder]="'search_form.doc_name_or_code' | translate" name="nameOrCode"
                       [(ngModel)]="documents.nameOrCode" maxlength="200" autocomplete="off">
                <button mat-button *ngIf="documents.nameOrCode" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="documents.nameOrCode=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Email/tên khách hàng -->
            <div class="col-lg-4 col-md-6">
              <mat-form-field class="w-100">
                <input type="text"
                       (focusout)="documents.customerName = documents.customerName == undefined ? '' : (documents.customerName + '').trim()"
                       matInput [placeholder]="'search_form.custommer_name_or_email' | translate" name="customerName"
                       [(ngModel)]="documents.customerName" maxlength="200" autocomplete="off">
                <button mat-button *ngIf="documents.customerName" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="documents.customerName=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <!-- Trạng thái -->
            <div class="col-lg-4 col-md-6">
              <mat-form-field class="w-100">
                <mat-label>{{'search_form.status' | translate}}</mat-label>
                <mat-select #statusSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                            (focus)="commonService.openComboBox(checkFocus, statusSelect)" id="status" name="status"
                            [(ngModel)]="documents.status" (ngModelChange)="onSearch(0,paginate.pageSize)"
                            [disabled]="!myForm.valid">
                  <mat-option [value]="''" selected (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'form.select_all' | translate}}</mat-option>
                  <mat-option [value]="enumContractStatus.DRAFT"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.draft' | translate}}</mat-option>
                  <mat-option [value]="enumContractStatus.PROCESSING"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.processing' | translate}}</mat-option>
                  <mat-option [value]="enumContractStatus.REJECTED"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.denied_sign' | translate}}</mat-option>
                  <mat-option [value]="enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT" *ngIf="isNotAttestedUser"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.wait_confirm_enterprice_no_moit' | translate}}</mat-option>
                  <mat-option [value]="enumContractStatus.FINISHED"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.finish' | translate}}</mat-option>
                  <mat-option [value]="enumContractStatus.CANCELLED"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.cancelled' | translate}}</mat-option>
                  <mat-option [value]="enumContractStatus.CONNECTING" *ngIf="!isNotAttestedUser"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.connecting' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            

            <!-- Thời gian nhận (từ ngày) -->
            <div class="col-lg-4 col-md-6" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <mat-label>{{ 'search_form.received_date_from' | translate }}</mat-label>
                <input matInput [matDatepicker]="receivedTimeFrom" [max]="documents.receivedTimeTo"
                       #receivedTimeFromCtrl="ngModel"
                       (change)="this.commonService.resetDatePicker(pickerInput.value, this.ngForm.controls['receivedTimeFrom'])"
                       name="receivedTimeFrom" #pickerInput [(ngModel)]="documents.receivedTimeFrom" maxlength="200"
                       (focus)="createdDateErr = 'fromDate'" autocomplete="off"/>
                <mat-datepicker-toggle matSuffix [for]="receivedTimeFrom">
                  <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                     [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                </mat-datepicker-toggle>
                <mat-datepicker #receivedTimeFrom></mat-datepicker>
                <mat-error *ngIf="receivedTimeFromCtrl?.errors?.matDatepickerParse">
                  {{'validation.format_of_date' | translate}}
                </mat-error>
                <mat-error *ngIf="receivedTimeFromCtrl?.errors?.matDatepickerMax && createdDateErr == 'fromDate'">
                  {{ 'search_form.received_date_from' | translate }}
                  {{ 'validation.from_date_smaller_than_or_equal_to_date' | translate }}
                  {{ 'search_form.received_date_to' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Thời gian lập (đến ngày) -->
            <div class="col-lg-4 col-md-6" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <mat-label>{{ 'search_form.received_date_to' | translate }}</mat-label>
                <input matInput [matDatepicker]="receivedTimeToRef" [min]="documents.receivedTimeFrom"
                       (change)="this.commonService.resetDatePicker(pickerInput1.value, this.ngForm.controls['receivedTimeTo'])"
                       name="receivedTimeTo" #pickerInput1 [(ngModel)]="documents.receivedTimeTo"
                       #receivedTimeToCtrl="ngModel"
                       maxlength="200" (focus)="createdDateErr = 'toDate'" autocomplete="off"/>
                <mat-datepicker-toggle matSuffix [for]="receivedTimeToRef">
                  <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                     [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                </mat-datepicker-toggle>
                <mat-datepicker #receivedTimeToRef></mat-datepicker>
                <mat-error *ngIf="receivedTimeToCtrl?.errors?.matDatepickerParse">
                  {{'validation.format_of_date' | translate}}
                </mat-error>
                <mat-error *ngIf="receivedTimeToCtrl?.errors?.matDatepickerMin && createdDateErr == 'toDate'">
                  {{ 'search_form.received_date_to' | translate }}
                  {{ 'validation.to_date_larger_than_or_equal_from_date' | translate }}
                  {{ 'search_form.received_date_from' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <!-- Tên người gửi  -->
            <div class="col-lg-4 col-md-6" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <input type="text"
                       (focusout)="documents.senderName = documents.senderName == undefined ? '' : (documents.senderName + '').trim()"
                       #focusInput matInput [placeholder]="'search_form.sender_name' | translate" name="senderName"
                       [(ngModel)]="documents.senderName" maxlength="200" autocomplete="off">
                <button mat-button *ngIf="documents.senderName" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="documents.senderName=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="col-lg-12 col-md-6 d-flex justify-content-end">
              <button *ngIf="!isBasicSearchForm" type="button" mat-button class="advance-search"
                      (click)="onCloseAdvancedSearchForm()">
                <span>{{'enterprise_contract.buttons.basic' | translate}}</span>
                <em class="material-icons">keyboard_arrow_up</em>
              </button>
              <button *ngIf="isBasicSearchForm" type="button" mat-button class="advance-search"
                      (click)="onExpandAdvancedSearchForm()">
                <span>{{'enterprise_contract.buttons.advance' | translate}}</span>
                <em class="material-icons">keyboard_arrow_down</em>
              </button>
            </div>
          </div>
          

          <!-- button tìm kiếm -->
          <div class="row mt-3">
            <div class="col-lg-12 d-flex justify-content-center">
              <button mat-stroked-button color="primary" type="submit" (click)="onClickBtnFilter()"
                      [disabled]="!myForm.valid || isTableLoading">
                <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                {{'enterprise_contract.buttons.search' | translate}}
              </button>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center list-title">
          <div class="title col-xs-12 pl-0">
          <span>{{'enterprise_contract.list_negotiate_contract' | translate}} ({{paginate.totalRow}}
            ), {{'enterprise_contract.selected_title' | translate}}: {{selection.selected.length}}</span>
          </div>
          <div class="d-flex buttonMD justify-content-end">
            <button class="btn1-mine" mat-stroked-button color="primary" type="button"
                      [matMenuTriggerFor]="menuColumn">
                <mat-icon>apps</mat-icon>
                {{'button.more_feature' | translate}}
            </button>
            <mat-menu #menuColumn="matMenu" >
              <button class="" mat-menu-item color="primary" type="button"
                    [disabled]="selection.selected.length === 0" (click)="multiDownload()">
                <mat-icon class="mr-0">save_alt</mat-icon>
                {{'button.downloadContract' | translate}}
              </button>
            </mat-menu>
          </div>
        </mat-panel-title>
        <div class="mat-table-container"  style=" display: block; max-height: 590px">
          <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)"
                     class="mat-table-col-extra-sm"  [ngStyle]="{'min-width': tableWidth + 'px'}">
            <!-- select -->
            <ng-container matColumnDef="select">
              <mat-header-cell *matHeaderCellDef
                               class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
                <mat-checkbox
                  *ngIf="dataSource && dataSource.data && dataSource.data.value && dataSource.data.value.length > 0"
                  (change)="$event ? masterToggle() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  color="primary"></mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom"
                        (click)="$event.stopPropagation()">
                <mat-checkbox
                  color="primary"
                  (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(element.id) : null"
                  [checked]="selection.isSelected(element.id)"
                >
                </mat-checkbox>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell check-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- STT -->
            <ng-container matColumnDef="STT">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{'enterprise_contract.table_headers.No' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                        (click)="$event.stopPropagation()">
                {{element.STT}}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell no-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Tài liệu Column -->
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef style="width: 20%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.document_code_name' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="width: 20%;">
                <span (click)="$event.stopPropagation()" matTooltip="{{element.name}}" class="fix-width"
                      style="margin-left: -5px;">
                  {{element.name}}
                </span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 20%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Khách hàng Column -->
            <ng-container matColumnDef="allName">
              <mat-header-cell *matHeaderCellDef style="max-width: 30%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.contract_parties' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.allName }}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                        style="max-width: 30%;">
                <span class="fix-width">{{ element.allName }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 30%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Email các bên ký hợp đồng Column -->
            <ng-container matColumnDef="allEmail">
              <mat-header-cell *matHeaderCellDef style="max-width: 15%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.contract_parties_email' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.allEmail }}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                        style="max-width: 15%;">
                <span class="fix-width">{{ element.allEmail }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 15%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Trạng thái   -->
            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef class="doc-status-col mat-cell-non-boder-right-bottom"
                               style="max-width: 10%;">
                {{'enterprise_contract.table_headers.document_status' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center"
                        style="max-width: 10%;"
                        (click)="$event.stopPropagation()">
                <nz-tag *ngIf="element.cStatus === enumContractStatus.DRAFT" style="margin-right: 0px;">
                  {{'search_form.draft' | translate}}</nz-tag>
                <nz-tag *ngIf="element.cStatus === enumContractStatus.PROCESSING" [nzColor]="'blue'"
                        style="margin-right: 0px;">{{'search_form.processing' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.cStatus === enumContractStatus.REJECTED" [nzColor]="'red'"
                        style="margin-right: 0px;">{{'search_form.denied_sign' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.cStatus === enumContractStatus.FINISHED && element.contractTerminationStatus != 2 && element.contractTerminationStatus != 4" [nzColor]="'green'"
                        style="margin-right: 0px;">{{'search_form.finish' | translate}}</nz-tag>
                <nz-tag *ngIf="element.cStatus === enumContractStatus.CANCELLED" [nzColor]="'red'"
                        style="margin-right: 0px;">{{'search_form.cancelled' | translate}}</nz-tag>
                <nz-tag *ngIf="element.cStatus == enumContractStatus.CONNECTING" [nzColor]="'blue'"
                        style="margin-right: 0px;">{{'search_form.connecting' | translate}}</nz-tag>
                <nz-tag *ngIf="element.cStatus == enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT"
                        class='wait-confirm-enterprice-no-moit__tag'
                        style="margin-right: 0px;">{{'search_form.wait_confirm_enterprice_no_moit' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status == enumContractStatus.FINISHED && element.contractTerminationStatus == 2"    
                        [nzColor]="'blue'"
                        style="margin-right: 0px;">{{'contract_terminate.terminating' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status == enumContractStatus.FINISHED && element.contractTerminationStatus == 4"
                        [nzColor]="'green'"
                        style="margin-right: 0px;">{{'contract_terminate.terminated' | translate}}</nz-tag>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell doc-status-col" style="max-width: 10%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>


            <!-- nguoi lap -->
            <ng-container matColumnDef="createdBy">
              <mat-header-cell *matHeaderCellDef style="max-width: 7%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise_contract.table_headers.created_by' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"  matTooltip="{{ element.createdBy }}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                        style="max-width: 7%; justify-content: center;">
                <span class="fix-width">{{ element.createdBy }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 7%; justify-content: center;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

          <!-- Thời gian nhận Column -->
          <ng-container matColumnDef="receivedTime">
            <mat-header-cell *matHeaderCellDef
                            class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="max-width: 11%;">
              {{'enterprise_contract.table_headers.received_date' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" [matTooltip]="element.receivedTime | dateformat"
                      class="mat-cell-non-boder-right-bottom number-cell-center"
                      (click)="$event.stopPropagation()" style="max-width: 11%;">
              <span class="fix-width">{{ element.receivedTime | dateformat}}</span>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 11%;">
              <span class="skeleton-cell"></span>
            </mat-footer-cell>
          </ng-container>


            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center">
                {{'headertable.action' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"
                        class="number-cell-center">

                <!-- Xem chi tiết -->
                <button mat-icon-button (click)="viewDetail(element, element.typeId)">
                  <mat-icon matTooltip="{{'enterprise_contract.tooltips.document_view' | translate}}">
                    visibility
                  </mat-icon>
                </button>

                <!-- Tải xuống -->
                <button mat-icon-button (click)="openPDFByBrowser(element)"
                        [disabled]="commonService.getIsLockedEnterprise()">
                  <mat-icon matTooltip="{{'enterprise_contract.buttons.download' | translate}}">save_alt
                  </mat-icon>
                </button>

              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row" [cdkDetailRow]="row"
                     (toggleChange)="onToggleChange($event,row)">
            </mat-row>
            <!-- hang skeleton trong bang: mat-footer-row render doc lap voi data nen ton tai
                 ca khi bang chua co du lieu; moi cot co mat-footer-cell rieng can theo
                 displayedColumns nen skeleton can theo dung cot; an/hien qua class theo isTableLoading -->
            <mat-footer-row *matFooterRowDef="displayedColumns"
                            class="table-skeleton-row"
                            [class.table-skeleton-hidden]="!isTableLoading"></mat-footer-row>
          </mat-table>
          </div>

        <!-- Pagination -->
        <app-pagination [(paginate)]="paginate" (pageChange)="onFilterData($event.page, $event.pageSize)"
                        [isShowNoRecord]="!isTableLoading">
        </app-pagination>
      </mat-expansion-panel>
    </mat-accordion>


  </mat-card-content>
</mat-card>
